import React, { useEffect, useRef, useState } from 'react'
import { getImages } from '../Common/const';

const HomeVideo = ({inView}) => {
    const videoRef = useRef(null);
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.autoplay = true;
            videoRef.current.muted = true;
            videoRef.current.loop = false;
            videoRef.current.controls = false;
        }
    }, []);

    const [isMobileView, setIsMobileView] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 991);
    };
    const [openGrandOpening, setOpenGrandOpening] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenGrandOpening(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (openGrandOpening) {
            setFadeIn(true);
        }
    }, [openGrandOpening]);
    useEffect(() => {
        const videoElement = videoRef.current;
        const handleVideoEnd = () => {
            videoElement.classList.add('video-fade-in');
            videoElement.play();
            setTimeout(() => {
                // videoElement.currentTime = 0;
                videoElement.classList.remove('video-fade-in');
            }, 3000);
        };
        if (videoElement) {
            videoElement.addEventListener('ended', handleVideoEnd);
        }
        return () => {
            if (videoElement) {
                videoElement.addEventListener('ended', handleVideoEnd);
            }
        };
    }, []);
  return (
    <>
        <section className={`video-wrap wow reveal fadeIn ${inView ? 'in-view' : ''}`}>
            <video className='video-background' width="100%" height='700' ref={videoRef} playsInline autoPlay>
                <source src={`${getImages('video.mp4')}`} type="video/mp4" />
                Your browser does not support the video tag.
            </video> 
        </section>
    </>
  )
}

export default HomeVideo